Jasper = window.Jasper || {};

Jasper.Forms = {
            init : function(){
                
                if ($(".select2").length){
                
                    $.fn.select2.defaults.set("theme", "bootstrap");

                    var $select2 = $(".select2");

                    $select2.select2({
                        //placeholder: placeholder,
                        width: null
                    });
                    
                    $select2
                        .on('select2:open select2:select', function(){ $(".select2").addClass('edited'); })
                        .on('select2:close select2:unselect', function(){
                            
                            if ( $select2.val() === "" ) {
                                $(".select2").removeClass('edited');
                            } else { 
                                $(".select2").addClass('edited');
                            }
                        });
                }
                
                if ($('input').length) {
                    $('input').each(function(){
                        $(this).on('input, change', function(){
                            if ($(this).val().length){
                              $(this).addClass('edited');  
                            } else {
                                $(this).removeClass('edited');
                            }
                        });
                    });    
                }

                if ($('form.validate').length){
                    $('form.validate').each(function() {
                        var form = new Jasper.Forms.ValidationForm($(this));
                    });    
                }
                
                if ($('textarea.autosize').length) {
                    Jasper.Forms.TextAreaAutoSize($('textarea.autosize'));    
                }
                
                
                $(".form_zip_step1").change(function(){
                    var zip_usa = $(".form_zip_step1").attr('zip_usa');
                    console.log(zip_usa);
                    var data_zip = {
                        zip_code: $(".form_zip_step1").val()
                    };
                    if(zip_usa == 'true')
                    {
                        $.ajax({
                            url: b.base_url + "ajax/find_usa_zip_code.php",
                            type: "POST",
                            data:data_zip,
                            success:function(result){
                                result = JSON.parse(result);
                                console.log(result);
                                $("#city").val(result.city);
                                $("#state2").val(result.area_id);
                            }

                        });
                    }
                });
                
                $(".country").change(function(){
                    if(parseInt($(this).val())==236){
                        $("#state2").show();
                        $("#state3").hide();

                        $(".form_zip_step1").attr('zip_usa','true');
                        $(".state2").rules("add", "required");
                    }else{
                        $("#state2").hide();
                        $("#state3").show();
                        $(".form_zip_step1").attr('zip_usa','false');
                        $(".state2").rules("remove", "required");
                    }
                });
                
            },
            TextAreaAutoSize : function($textarea){
                $textarea.attr('rows', 1).css({minHeight: 34,maxHeight: 150});
                autosize($textarea);
            },
            
            ValidationForm : function($form){
                var $error = $('.alert-danger', $form);
                var $success = $('.alert-success', $form);

                $form.validate({
                    errorElement: 'span', //default input error message container
                    errorClass: 'help-block help-block-error', // default input error message class
                    focusInvalid: false, // do not focus the last invalid input
                    ignore: "", // validate all fields including form hidden input
                    rules: {
                        email: {
                            required: true,
                            email: true
                        }
                    },

                    messages: { // custom messages for radio buttons and checkboxes
                        
                    },

                    invalidHandler: function(event, validator) { //display error alert on form submit              
                        $success.hide();
                        $error.show();
                        App.scrollTo($error, -200);
                    },

                    errorPlacement: function(error, element) {
                        if (element.is(':checkbox')) {
                            error.insertAfter(element.closest(".md-checkbox-list, .md-checkbox-inline, .checkbox-list, .checkbox-inline"));
                        } else if (element.is(':radio')) {
                            error.insertAfter(element.closest(".md-radio-list, .md-radio-inline, .radio-list,.radio-inline"));
                        } else {
                            error.insertAfter(element); // for other inputs, just perform default behavior
                        }
                    },

                    highlight: function(element) { // hightlight error inputs
                        $(element)
                            .closest('.form-group').addClass('has-error'); // set error class to the control group
                    },

                    unhighlight: function(element) { // revert the change done by hightlight
                        $(element)
                            .closest('.form-group').removeClass('has-error'); // set error class to the control group
                    },

                    success: function(label) {
                        label
                            .closest('.form-group').removeClass('has-error'); // set success class to the control group
                    },

                    submitHandler: function(form) {
                        $success.show();
                        $error.hide();
                        form.submit();
                    }


                });
            }
            
            
            
            
            
};


$(document).ready(function(){
    Jasper.Forms.init();
});

